import Stickyfill from 'stickyfilljs';

export default function sticky() {

  var stickyPos = document.querySelectorAll('.js-sticky');
  Stickyfill.add(stickyPos);

}